'use client';

import React from 'react';
import FeedbackStarRating from './FeedbackStarRating';

type FeedbackStepHeaderProps = {
  question: string;
  rating: number;
  hoveredRating: number | null;
  onRatingSelect: (rating: number) => void;
  onRatingHover: (rating: number | null) => void;
  stepTitle?: string;
  stepIndicator?: string;
  showStepMeta?: boolean;
};

const FeedbackStepHeader = ({
  question,
  rating,
  hoveredRating,
  onRatingSelect,
  onRatingHover,
  stepTitle,
  stepIndicator,
  showStepMeta = false,
}: FeedbackStepHeaderProps) => {
  return (
    <div className="it-feedback-step-header">
      <h2 className="it-customer-rating-title mb-0">{question}</h2>

      <FeedbackStarRating
        rating={rating}
        hoveredRating={hoveredRating}
        onSelect={onRatingSelect}
        onHover={onRatingHover}
      />

      {showStepMeta && stepTitle ? (
        <div className="d-flex align-items-center justify-content-between gap-3 it-feedback-step-meta">
          <p className="it-feedback-step-title mb-0">{stepTitle}</p>
          {stepIndicator ? (
            <span className="it-feedback-step-indicator">{stepIndicator}</span>
          ) : null}
        </div>
      ) : null}

      {showStepMeta ? <div className="it-feedback-divider-shadow" /> : null}
    </div>
  );
};

export default FeedbackStepHeader;
